import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { VatAnnualDeclaration } from "../../types";
import {
  VatAnnualDeclarationStatus,
  UpdateVatAnnualDeclarationInput as GeneratedUpdateVatAnnualDeclarationInput,
} from "../../schema.generated";

/*
 * `resetApproval` comes from the generated schema rather than being restated
 * here: it confirms that moving the declaration into "Warten auf
 * Kundenfreigabe" may reset the approval the customer gave for the previous
 * version. Without it the backend refuses that status change with
 * APPROVAL_RESET_REQUIRED. A save that leaves the status unchanged never
 * needs it.
 */
export interface UpdateVatAnnualDeclarationInput
  extends Pick<GeneratedUpdateVatAnnualDeclarationInput, "resetApproval"> {
  status: VatAnnualDeclarationStatus;
  lastYearIncomeAdjustment: number | null;
  currentYearIncomeAdjustment: number | null;
  taxOfficeBalance: number | null;
}

export interface UpdateVatAnnualDeclarationMutationVariables {
  email: string;
  year: number;
  payload: UpdateVatAnnualDeclarationInput;
}

export interface UpdateVatAnnualDeclarationMutationResult {
  updateVatAnnualDeclaration: VatAnnualDeclaration;
}

export const UPDATE_VAT_ANNUAL_DECLARATION_MUTATION = gql`
  mutation updateVatAnnualDeclaration(
    $email: String!
    $year: Int!
    $payload: UpdateVatAnnualDeclarationInput!
  ) {
    updateVatAnnualDeclaration(email: $email, year: $year, payload: $payload) {
      status
      statusUpdatedAt
      lastYearIncomeAdjustment
      currentYearIncomeAdjustment
      taxOfficeBalance
    }
  }
`;

export const useUpdateVatAnnualDeclarationMutation = (
  options?: MutationHookOptions<
    UpdateVatAnnualDeclarationMutationResult,
    UpdateVatAnnualDeclarationMutationVariables
  >
) =>
  useMutation<
    UpdateVatAnnualDeclarationMutationResult,
    UpdateVatAnnualDeclarationMutationVariables
  >(UPDATE_VAT_ANNUAL_DECLARATION_MUTATION, options);
